import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

const TABLE_QUERY_MAP: Record<string, string[][]> = {
  homepage_sections: [["homepage-sections"], ["admin-homepage-sections"]],
  contact_info: [["contact-info"], ["admin-contact-info"]],
  properties: [["properties"], ["admin-properties"], ["admin-properties-count"]],
  apartments: [["apartments"], ["apartment"], ["admin-apartments-full"], ["admin-apartments-count"]],
  apartment_translations: [["apartments"], ["apartment"], ["admin-apartments-full"]],
  apartment_images: [["apartments"], ["apartment"], ["admin-apartments-full"]],
  pages: [["admin-pages-full"], ["admin-pages-count"]],
  page_translations: [["admin-pages-full"]],
  media: [["admin-media"], ["admin-media-count"], ["admin-apartments-full"]],
  menu_items: [],
  menu_item_translations: [],
  languages: [],
};

export const useCmsRealtime = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const channel = supabase
      .channel("cms-live-sync")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "homepage_sections" },
        () => invalidateForTable("homepage_sections")
      )
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "contact_info" },
        () => invalidateForTable("contact_info")
      )
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "properties" },
        () => invalidateForTable("properties")
      )
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "apartments" },
        () => invalidateForTable("apartments")
      )
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "apartment_translations" },
        () => invalidateForTable("apartment_translations")
      )
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "apartment_images" },
        () => invalidateForTable("apartment_images")
      )
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "pages" },
        () => invalidateForTable("pages")
      )
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "page_translations" },
        () => invalidateForTable("page_translations")
      )
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "media" },
        () => invalidateForTable("media")
      )
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "menu_items" },
        () => invalidateForTable("menu_items")
      )
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "menu_item_translations" },
        () => invalidateForTable("menu_item_translations")
      )
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "languages" },
        () => invalidateForTable("languages")
      )
      .subscribe();

    function invalidateForTable(table: keyof typeof TABLE_QUERY_MAP) {
      TABLE_QUERY_MAP[table].forEach((queryKey) => {
        queryClient.invalidateQueries({ queryKey });
      });
    }

    return () => {
      supabase.removeChannel(channel);
    };
  }, [queryClient]);
};